import { API_ENDPOINT } from './config';

const BASE_URL = 'fri-internal-jobs';

export const urlsFriInternalJobs = {
  fijJobs: `${API_ENDPOINT}/${BASE_URL}/jobs`,
  fijJobsPublic: `${API_ENDPOINT}/${BASE_URL}/jobs/public`,
  fijJobsList: `${API_ENDPOINT}/${BASE_URL}/jobs?approved=true`,
  fijListOfMyJobs: `${API_ENDPOINT}/${BASE_URL}/jobs?my-${BASE_URL}=true`,
  fijJobDetail: (id) => `${API_ENDPOINT}/${BASE_URL}/jobs/${id}`,
  fijJobApprove: (id) => `${API_ENDPOINT}/${BASE_URL}/jobs/${id}/approve`,
  fijJobReject: (id) => `${API_ENDPOINT}/${BASE_URL}/jobs/${id}/reject`,
  fijJobArchive: (id) => `${API_ENDPOINT}/${BASE_URL}/jobs/${id}/archive`,
  fijJobRestore: (id) => `${API_ENDPOINT}/${BASE_URL}/jobs/${id}/restore`,
  fijAreaOfUses: `${API_ENDPOINT}/${BASE_URL}/area-of-uses`,
  fijStudentFailed: (id) => `${API_ENDPOINT}/${BASE_URL}/interests/fail/${id}`,
  fijStudentSucceeded: (id) =>
    `${API_ENDPOINT}/${BASE_URL}/interests/success/${id}`,
  fijRejectInterest: (id) =>
    `${API_ENDPOINT}/${BASE_URL}/interests/reject/${id}`,
  fijMyAssignedProject: `${API_ENDPOINT}/${BASE_URL}/interests?my-project=true`,
  fijMyInterests: `${API_ENDPOINT}/${BASE_URL}/interests`,
  fijInterestsDetail: (id) => `${API_ENDPOINT}/${BASE_URL}/interests/${id}`,
  fijCreateInterest: `${API_ENDPOINT}/${BASE_URL}/interests`,
  fijUpdateInterest: (id) => `${API_ENDPOINT}/${BASE_URL}/interests/${id}`,
  fijJobInterns: (id) => `${API_ENDPOINT}/${BASE_URL}/jobs/${id}/interns`,
  fijAcceptInterest: (id) =>
    `${API_ENDPOINT}/${BASE_URL}/interests/accept/${id}`,
};

export const routesFriInternalJobs = {
  // Public
  fijJobs: '/fakultne-praxe',
  fijJobDetail: '/fakultna-prax',

  // CMS
  cmsFijJobs: `/cms/${BASE_URL}/jobs`,
  cmsFijJobCreate: `/cms/${BASE_URL}/job/create`,
  cmsFijJobEdit: `/cms/${BASE_URL}/job/edit`,
  cmsFijJobDetail: `/cms/${BASE_URL}/job/detail`,

  cmsFijInterestedStudents: `/cms/${BASE_URL}/interested`,
  cmsFijInterestDetail: `/cms/${BASE_URL}/interest/detail`,
  cmsFijInterestsCreate: `/cms/${BASE_URL}/interest/create`,
  cmsFijJobInterestsEdit: `/cms/${BASE_URL}/interest/edit`,

  cmsFijJobListOfMyInterests: `/cms/${BASE_URL}/my-interests`,
};
